import Rellax from 'rellax';

document.addEventListener('DOMContentLoaded', function(){
    if(document.getElementsByClassName('rellaxNO').length>=1){
        var rellax = new Rellax('.rellaxNO', {
            center: true,
            wrapper: null,
            round: true,
            vertical: true,
            horizontal: false,
            
          });
    }
})
